import { inject, Injectable } from '@angular/core';
import { PRODUCT_THEME, Products } from '../interfaces/state-interface';
import { BehaviorSubject, Subject } from 'rxjs';
import { DataService } from './data/data.service';
import { RequestParam } from '../interfaces/requestParam';
import { API_CONSTANTS } from '../static/api.constant';
import { IToast } from '@sarasanalytics-com/design-system';
import { CookiesService } from './cookies/cookies.service';
import { NS_Enums } from '../static/namespace';
import { StoreService } from './store/store.service';
import { normalizeEmail } from '../shared/email.helper';

const baseWord = 'u';
const uncommonBaseWord = '';

declare global {
  interface Window {
    dataLayer: any;
  }
  interface document {}
}
@Injectable({
  providedIn: 'root',
})
export class AppService {

  private dataService: DataService = inject(DataService); 
  private cacheService: CookiesService = inject(CookiesService);
  private store: StoreService = inject(StoreService);

  // public toastEvent$: Subject<IToast> = new Subject();
  public toastEvent$: BehaviorSubject<IToast | null> = new BehaviorSubject<IToast | null>(null);

  $showWelcomeView: BehaviorSubject<boolean> = new BehaviorSubject(false);

  $maintenanceMode: BehaviorSubject<boolean> = new BehaviorSubject(false);
  setProductType(product: Products) {
    document.body.classList.remove('purple-theme');
    document.body.classList.remove('daton-theme');
    document.body.classList.remove('saras-theme');
    document.body.classList.remove('iq-theme');
    document.body.classList.add(PRODUCT_THEME[product]);
  }

  /* EMAIL address that have '+' in it is replaced with ' ' (space) when recieved via query param
    * replace the ' ' (space) with '+' and return the string.
    * Also trims surrounding whitespace and lowercases the address for case-insensitive matching.
  */
  sanitizeEmailFromParams(email: string): string {
    if(email){
      return normalizeEmail(email).replace(/ /g, "+");
    }
    return '';
  }

  getServiceStatus() {
    // const url = `${this.appUrl}services/status`;
    const headerMaps = new Map();
    headerMaps.set('skip', 'true');
    const requestParam: RequestParam = {
      url: API_CONSTANTS.SERVICE_STATUS,
      headers: Object.fromEntries(headerMaps)
    };
    return this.dataService.get(requestParam);
  }

  recorrectSarasGlobalCookie(){
    const saras_global:any = this.cacheService.getObject(NS_Enums.saras_global);
    const userDetails: any = this.store.getUser();
    const token: string = this.store.getToken();
    if(saras_global){
      if(!saras_global.userId && userDetails?.userId){
        saras_global.userId = userDetails.userId;
      }
      if(!saras_global.token && token){
        saras_global.token = token;
      }
      this.cacheService.addSharedCookie(saras_global);
      return (saras_global.userId && saras_global.token) || false;
    }
    return false;
  }
}
